module.exports = __webpack_public_path__ + "img/4.cc74e6d6.jpeg";